import apiClient from './api_client_requests';

export default async (payload) => {
    let result = await apiClient.apiMethod({
        method: 'GetBanners',
        args: {},
    });

    const response = {
        banners: [],
        error: null,
    };

    if (result?.response?.code > 299) {
        response.error = response.message;
    } else {
        response.banners = result.slides;
    }

    return response;
};
